import type { FC } from "react";

import { i18nFilter } from "app/filters/i18nFilter";
import { AssetsService } from "app/services/AssetsService";
import { ConversionScatterChart } from "pro-features/pages/conversion/components/ConversionScatterChart/ConversionScatterChart";

import type { Metrics, ScatterChartConfig, ScatterItems } from "../../types";
import { XAxisLabel, YAxisLabel } from "../AxisLabels/AxisLabels";

import { ScatterWrapper, ScatterContent, ChartContainer } from "./styledComponent";

interface ICompetitorsScatterProps {
    scatterDataItems: ScatterItems;
    metrics: Metrics;
    config: ScatterChartConfig;
}
const CompetitorsScatter: FC<ICompetitorsScatterProps> = ({ scatterDataItems, metrics, config }) => {
    const cursorUrl = AssetsService.assetUrl(`/images/scatter/dragtozoom_cursor@3x.svg`);

    return (
        <ChartContainer cursorUrl={cursorUrl}>
            <ScatterContent>
                <YAxisLabel
                    title={config.yAxis.title}
                    tooltip={config.yAxis.tooltip}
                />
                <ScatterWrapper>
                    <ConversionScatterChart
                        data={scatterDataItems}
                        metrics={metrics}
                        config={config}
                        options={{ efficiencyZones: false }}
                        translate={i18nFilter()}
                    />
                </ScatterWrapper>
            </ScatterContent>
            <XAxisLabel
                title={config.xAxis.title}
                tooltip={config.xAxis.tooltip}
            />
        </ChartContainer>
    );
};

export default CompetitorsScatter;
